module.exports = "/365FarmNet/dist/cattle.e99b2c24dfbf55a98655dc3c32e1eed1.html";